import gql from "graphql-tag";

export const getLogBookStickerDataQuery = gql`
  query GetLogBookStickerData($tenantId: ID!, $taskId: ID!) {
    getLogBookStickerData(tenantId: $tenantId, taskId: $taskId)
  }
`;
